<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
      <el-form-item label="Enabled">
        <el-checkbox v-model="form.enabled"></el-checkbox>
      </el-form-item>
      <el-form-item label="Set Point (inHg)">
        <el-input v-model="form.setPoint" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Deadband (inHg)">
        <el-input v-model="form.deadband" type="number"></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,
      form: {
        enabled: false,
        setPoint: "",
        deadband: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.form.setPoint)) || parseInt(this.form.setPoint) < 0 || parseInt(this.form.setPoint) > 50) {
        const h = this.$createElement
        this.$notify({
          title: "Setpoint",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.deadband)) || parseInt(this.form.deadband) < 0 || parseInt(this.form.deadband) > 50) {
        const h = this.$createElement
        this.$notify({
          title: "Deadband",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        })
        return false
      }
      return true
    },
    roundHalf(num) {
      return Math.round(num * 2) / 2
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return true
      this.loading = true
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, "Settings.Differential.Enabled", this.form.enabled ? "true" : "false"),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Differential.Setpoint", this.roundHalf(parseFloat(this.form.setPoint)) / 2.036),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Differential.Deadband", this.roundHalf(parseFloat(this.form.deadband)) / 2.036)
      ])
        .then(
          Axios.spread((enabledResponse, setPointResponse, deadbandResponse) => {
            //The system should update in 10 seconds.
            this.loading = false
            if (enabledResponse.data.result != "success" || setPointResponse.data.result != "success" || deadbandResponse.data.result != "success") {
              const h = this.$createElement
              this.$notify({
                title: "Differential",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.$notify({
                title: "Differential",
                message: "Settings Saved to Panel",
                type: "info"
              })
              this.getData()
            }
          })
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Differential",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },

    getData() {
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          this.form.enabled = settingsResponse.data.differential.enabled == "true"
          this.form.setPoint = (parseFloat(settingsResponse.data.differential.setpoint) * 2.036).toFixed(1)
          this.form.deadband = (parseFloat(settingsResponse.data.differential.deadband) * 2.036).toFixed(1)
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// Differential.vue?00d7121a